import { createSlice } from "@reduxjs/toolkit";

const styleSlice = createSlice({
  name: "style",
  initialState: {
    // dari API
    card_title: null,
    primary_color: "#166534", // default green-800
    primary_text_color: "#0D8DE3",
    secondary_color: "#111827", // default gray-900
    secondary_text_color: "#1E2635",
    tertiary_text_color: "#ffffff",
    background_type: null, // default tech, options: tech, gradient
    background_custom: null, // URL untuk custom background
    background_custom_url: null,
    
    // manual
    logo_url: null,
    background_color: "#ffffff",
    // Tambahkan field lain sesuai kebutuhan dari API
  },
  reducers: {
    setStyle: (state, action) => {
      // Update semua style properties yang ada di payload
      return { ...state, ...action.payload };
    },
    clearStyle: (state) => {
      // Reset ke default dari api
      state.card_title = null;
      state.primary_color = "#166534";
      state.primary_text_color = "#0D8DE3";
      state.secondary_color = "#111827";
      state.secondary_text_color = "#1E2635";
      state.tertiary_text_color = "#ffffff";
      state.background_type = null; // default tech, options: tech, gradient
      state.background_custom = null;
      state.background_custom_url = null;

      // manual
      state.logo_url = null;
      state.background_color = "#ffffff";
    },
  },
});

export const { setStyle, clearStyle } = styleSlice.actions;
export default styleSlice.reducer;
